export const faqs = [
  {
    key: 1,
    question: "What do I need to rent a vehicle?",
    answer:
      "Each person who intends to drive must bring a valid driver's license, passport, and a valid means of payment (generally via credit card). All of these items must be submitted on the day the vehicle will be picked up. Kindly pay with an affiliated credit card. If you wish to pay in cash, you must also submit an item of identification (copies are acceptable) in addition to your driver's license.",
  },
  {
    key: 2,
    question: "Do I need insurance?",
    answer:
      "We offer a wide range of rental insurance products for people who want to be on the safe side.",
  },
  {
    key: 3,
    question: "Can anyone besides the reservation applicant drive the vehicle?",
    answer:
      "Yes; however, each person who intends to drive the vehicle must submit a valid driver’s license on the day the vehicle will be picked up. If it is not possible for all drivers to be present on the day of pick-up, a copy of their driver’s license (both sides) and passport must be prepared in advance and submitted.",
  },
  {
    key: 4,
    question: "Can I rent a vehicle without a reservation?",
    answer:
      "Yes, as long as a vehicle is available in the station; however, we recommend making a reservation because no vehicle may be available during busy periods.",
  },
  {
    key: 5,
    question: "For how many days can I reserve a rental vehicle?",
    answer:
      "We accept reservations for a rental period of one (1) month at most.",
  },
];
